import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-readonly-float-label',
  standalone: true,
  imports: [],
  templateUrl: './readonly-float-label.html',
  styleUrl: './readonly-float-label.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadonlyFloatLabel {
  /** Label, das über dem Inhalt angezeigt wird */
  @Input({ required: true }) label: string;
}
